export const dropAnimation = {
  initial: { y: -10, opacity: 0, transition: { duration: 0.15 } },
  animate: { y: 0, opacity: 1, transition: { duration: 0.2 } },
  exit: { y: -20, opacity: 0, transition: { duration: 0.15 } },
};

export const drawingOptions = {
  fillColor: "gray",
  fillOpacity: 0.1,
  strokeColor: "red",
  strokeOpacity: 1,
  strokeWeight: 2,
  clickable: false,
  draggable: false,
  editable: false,
  geodesic: false,
  zIndex: 1,
};
export const shapeOptions = {
  fillColor: "gray",
  fillOpacity: 0.15,
  strokeColor: "black",
  strokeOpacity: 0.5,
  strokeWeight: 2,
  zIndex: 1,
};
export const activeShapeOptions = {
  fillColor: "gray",
  fillOpacity: 0.1,
  strokeColor: "#222263",
  strokeOpacity: 1,
  strokeWeight: 2,
  zIndex: 1,
};

// Graph Card style
export const graphCardStyles = {
  border: "2px solid #ddd",
  background: "#fff",
  borderRadius: "lg",
  height: "auto",
  overflow: "hidden",
  p: "3",
};
